import { IApplicationState } from '../../types/redux';

export function getQuestionsLoading(state: IApplicationState) {
  return state.questions.loading;
}
